export const emailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;

export const noWhiteSpaceRegex = /^\s*$/;

export const onlyNumbersRutRegex = /^[0-9]+-[0-9kK]{1}$/;

export const rutRegex = /^(\d{1,3}(?:\.\d{1,3}){2}-[\dkK])$/;

export const rucRegex = /^(10|15|16|17|20)\d{9}$/;

export const nitRegex = /^(\d{1,3}(?:\.\d{1,3}){2}-[\d])$/;

export const nuipRegex = /^\d{1,11}$/;

export const dniArgentinaRegex = /^\d{7,8}$/;

export const cuitArgentinaRegex = /^(20|23|24|27|30|33|34)-\d{8}-\d{1}$/;

export const ciParaguayRegex = /^\d{7,9}$/;

export const rucParaguayRegex = /^\d{6,8}-\d{1}$/;

export const dniNieSpainRegex = /^(\d{8}[A-Z]|[XYZ]\d{7}[A-Z])$/;

export const dniSpainRegex = /^\d{8}[A-Z]$/;

export const nieSpainRegex = /^[XYZ]\d{7}[A-Z]$/;

export const nifSpainRegex = /^[A-Z]\d{7}[A-Z0-9]$/;

export const urlRegex =
  /^(https?:\/\/|www\.)[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}(?:[-a-zA-Z0-9()@:%_+.~#?&//=]*)$/;

/** Matches URLs inside text (no ^ $) for linkification. Supports http(s) and www. */
export const urlInTextRegex =
  /(https?:\/\/|www\.)[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}(?:[-a-zA-Z0-9()@:%_+.~#?&//=]*)/g;

export const googleSheetsUrlRegex = /^https:\/\/docs.google.com\/spreadsheets\/d\/[a-zA-Z0-9-_]+/;

export const phoneNumberRegex = /^(?=.[0-9])/;

export const passwordRegex = /^(?=.{6,})/;
